const TABS = {
  resultado: 'resultado',
  ranking: 'ranking',
  gabarito: 'gabarito',
};

export default TABS;
